import {
  Card,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@material-ui/core";
import React, { FC } from "react";
import { CloneButton, EditButton, usePermissions } from "react-admin";
import { Raffle } from "../../types/raffle";
import TablePagination from "@material-ui/core/TablePagination";
import { useDispatch } from "react-redux";
import { setMark } from "../../redux/actions/propertyActions";
import LastPageIcon from "@material-ui/icons/LastPage";
import { checkPermission } from "../../helpers/checkPermissions";

interface NewRafflesProps {
  raffles: Array<Raffle> | null;
  changeStatus: (raffle: Raffle) => void;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleLastPage: () => Promise<void>;
  rowsPerPage: number;
  total: number;
  page: number;
}

const NewDreamHomeList: FC<NewRafflesProps> = ({
  raffles,
  changeStatus,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  total,
  page,
  handleLastPage,
}) => {
  let { permissions } = usePermissions();
  const dispatch = useDispatch();
  const markClone = () => {
    dispatch(setMark());
  };

  const activeStatus = (item: Raffle) => {
    item.active = true;
    changeStatus(item);
  };

  return (
    <Card className="active-table-card">
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow className="order-row">
              <TableCell id="active-table-head" align="left">
                #
              </TableCell>
              <TableCell id="active-table-head" align="left">
                Title
              </TableCell>
              {checkPermission(permissions, "Dream home", "Update") && (
                <TableCell id="active-table-head-actions" align="left">
                  Actions
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          {raffles
            ? raffles.map((item: Raffle) => {
                return (
                  <TableBody key={item.id}>
                    <TableRow className="order-row">
                      <TableCell component="th">{item.id}</TableCell>
                      <TableCell>{item.title}</TableCell>

                      {checkPermission(permissions, "Dream home", "Update") && (
                        <TableCell>
                          {raffles ? (
                            <div className="actions-table-body">
                              <CloneButton
                                record={item}
                                to={`dreamhome/${item.id}`}
                                onClick={markClone}
                              />
                              <EditButton
                                to={`dreamhome/${item.id}`}
                                className="edit-dreamhome"
                              />
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={item.active}
                                  onClick={() => activeStatus(item)}
                                />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </TableCell>
                      )}
                    </TableRow>
                  </TableBody>
                );
              })
            : null}
        </Table>
        <Box
          display="flex"
          alignItems="center"
          paddingRight="1em"
          justifyContent="flex-end"
        >
          <TablePagination
            component="div"
            count={total}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
          <div className="last-page-icon" title="Last Page">
            <LastPageIcon className="last-icon" onClick={handleLastPage} />
          </div>
        </Box>
      </TableContainer>
    </Card>
  );
};

export default NewDreamHomeList;
